import { render, staticRenderFns } from "./ContactoModalEdicion.vue?vue&type=template&id=35710ea8&scoped=true&"
import script from "./ContactoModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ContactoModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ContactoModalEdicion.vue?vue&type=style&index=0&id=35710ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35710ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('35710ea8', component.options)
    } else {
      api.reload('35710ea8', component.options)
    }
    module.hot.accept("./ContactoModalEdicion.vue?vue&type=template&id=35710ea8&scoped=true&", function () {
      api.rerender('35710ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Contactos/ContactoModalEdicion.vue"
export default component.exports